// AV TECH SIGNHUB — brand mark
// A premium geometric "AV" monogram badge with gradient + glow, plus wordmark.

export function AVMark({ size = 40, glow = true }) {
  const radius = Math.round(size * 0.28);
  return (
    <div
      className="relative inline-flex items-center justify-center flex-shrink-0"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: "linear-gradient(140deg, #0A84FF 0%, #2E9BFF 45%, #19E3FF 100%)",
        boxShadow: glow
          ? "0 0 0 1px rgba(255,255,255,0.12) inset, 0 8px 28px rgba(10,132,255,0.55), 0 0 38px rgba(25,227,255,0.35)"
          : "0 0 0 1px rgba(255,255,255,0.12) inset",
      }}
    >
      {/* glossy top highlight */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          borderRadius: radius,
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0.05) 38%, rgba(255,255,255,0) 60%)",
        }}
      />
      <svg
        width={size}
        height={size}
        viewBox="0 0 56 56"
        fill="none"
        className="relative"
        style={{ filter: "drop-shadow(0 1px 1px rgba(0,30,80,0.45))" }}
      >
        <defs>
          <linearGradient id="av-stroke" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#ffffff" />
            <stop offset="1" stopColor="#E3F2FF" />
          </linearGradient>
        </defs>
        <g
          stroke="url(#av-stroke)"
          strokeWidth="4.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        >
          {/* A */}
          <path d="M11 41 L19.5 16 L28 41" />
          <path d="M15 32.5 L24 32.5" />
          {/* V */}
          <path d="M29 16 L37 41 L45 16" />
        </g>
      </svg>
    </div>
  );
}

export function AVWordmark({ size = "md", className = "" }) {
  const scale = {
    sm: { a: "text-lg", s: "text-[9px]", gap: "mt-1" },
    md: { a: "text-2xl", s: "text-[10px]", gap: "mt-1" },
    lg: { a: "text-3xl", s: "text-[11px]", gap: "mt-1.5" },
    xl: { a: "text-4xl", s: "text-xs", gap: "mt-2" },
  }[size];
  return (
    <div className={`flex flex-col leading-none ${className}`}>
      <span
        className={`font-display font-black tracking-tight ${scale.a}`}
        style={{
          background: "linear-gradient(95deg, #FFFFFF 0%, #BFE2FF 50%, #19E3FF 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
          color: "transparent",
          filter: "drop-shadow(0 2px 12px rgba(25,227,255,0.45))",
        }}
      >
        SignHub
      </span>
      <span className={`font-semibold uppercase tracking-[0.28em] text-primary/80 ${scale.gap} ${scale.s}`}>
        Powered by AV&nbsp;Tech
      </span>
    </div>
  );
}

export function AVLogo({ markSize = 40, wordSize = "md", glow = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <AVMark size={markSize} glow={glow} />
      <AVWordmark size={wordSize} />
    </div>
  );
}
